import React from "react";
import { IoChevronDown } from "react-icons/io5";

/** 帳單明細內：列印下拉、摺疊區塊共用旋轉動畫 */
export const CHECKOUT_COLLAPSE_CHEVRON_TRANSITION =
  "transform 0.2s cubic-bezier(0.4, 0, 0.2, 1)";

/**
 * @param {object} props
 * @param {boolean} props.expanded 展開時箭頭朝下；收合時箭頭朝右（ChevronDown 逆時針 90°）
 * @param {number} [props.size]
 * @param {string} [props.color]
 */
export default function CheckoutCollapseChevron({
  expanded,
  size = 18,
  color = "currentColor",
  style = {},
}) {
  return (
    <IoChevronDown
      aria-hidden
      style={{
        flexShrink: 0,
        width: size,
        height: size,
        color,
        transition: CHECKOUT_COLLAPSE_CHEVRON_TRANSITION,
        transform: expanded ? "rotate(0deg)" : "rotate(-90deg)",
        ...style,
      }}
    />
  );
}
